// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const ViewService = {
    Merchant(fn, req) {
        return fn(`/payments/views/service/merchant?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    Merchants(fn, req) {
        return fn(`/payments/views/service/merchants?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    AppendInvoiceHistory(fn, req) {
        try {
            fm.validateUrlParam(req["invoiceId"], "invoiceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/views/service/invoices/${req["invoiceId"]}/history`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetInvoiceHistory(fn, req) {
        try {
            fm.validateUrlParam(req["invoiceId"], "invoiceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/views/service/invoices/${req["invoiceId"]}/history?${fm.renderURLSearchParams(req, ["invoiceId"])}`, { method: "GET" });
    },
    GetMultiLocationPricing(fn, req) {
        return fn(`/payments/views/service/pricing?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    GetMultiLocationStripeProcessors(fn, req) {
        return fn(`/payments/views/service/processors?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    LocationFeatureSettings(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/views/service/locations/${req["locationId"]}/feature-settings?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    SetLocationFeatureEnabled(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/payments/views/service/locations/${req["locationId"]}/feature-settings`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetMerchantsTerminalLocations(fn, req) {
        return fn(`/payments/views/service/merchants/terminal-locations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
